import React from 'react';
import logo from '../images/barista-tab-logo.png';
import tellko_logo from '../images/tellko_logo.png';

export default function login() {
    return(
        <div className='login_body'>
            <div className="container">
                <div className="row vh-100">

                    <div className="col-xxl-5 col-xl-5 col-lg-6 col-md-6 col-sm-6 col-12 ms-auto d-flex flex-wrap align-content-center h-100">

                        <div className="login_form_box shadow rounded">
                            {/* logo */}
                             <img src={logo} alt='' className='d-block mb-3' style={{ width: '150px' }}></img>
                            {/* logo */}
                            <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
                            </p>

                             <p className='fw-bold mb-2'>Please enter your details.</p>

                            <form className="w-100">
                            <div class="form-floating mb-3">
                                <input type="email" className="form-control" id="floatingInput" placeholder="name@example.com"></input>
                                <label for="floatingInput">NIC</label>
                            </div>
                            <div className="form-floating">
                                <input type="password" className="form-control" id="floatingPassword" placeholder="Password"></input>
                                <label for="floatingPassword">Password</label>
                            </div>
                            
                            {/* forgot password */}
                            <p><a href='/' className='fst-italic text-end w-100 d-block mt-2 mb-2'>Forgot Password?</a></p>
                            {/* forgot password */}

                            {/* submit button */}
                            <a href='/'>
                                 <button type="button" className="btn black_btn mt-0 w-100">
                                    SUBMIT  &nbsp;
                                    <svg width="29" height="12" viewBox="0 0 29 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M28.0303 6.53033C28.3232 6.23744 28.3232 5.76257 28.0303 5.46967L23.2574 0.696701C22.9645 0.403808 22.4896 0.403808 22.1967 0.696701C21.9038 0.989594 21.9038 1.46447 22.1967 1.75736L26.4393 6L22.1967 10.2426C21.9038 10.5355 21.9038 11.0104 22.1967 11.3033C22.4896 11.5962 22.9645 11.5962 23.2574 11.3033L28.0303 6.53033ZM0.5 6.75L27.5 6.75L27.5 5.25L0.5 5.25L0.5 6.75Z" fill="white"/>
                                    </svg>
                                </button>
                            </a>
                            {/* submit button */}
                           
                            </form>

                            <p className='mt-4 mb-2' style={{color: '#000000', fontSize: '12px'}}>Copyright © 2025 All rights reserved.</p>
                            <p className='mt-0 mb-0' style={{color: '#000000', fontSize: '12px'}}>Powered By &nbsp;<img src={tellko_logo} alt='' className='d-inline-block' style={{ width: '80px' }}></img></p>
                        </div>

                    </div> 

                    <div className="clearfix"></div>

                </div>
            </div>
        </div>
    );
};